// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
if (!Components.Utils) Components.Utils = {};

Components.Utils.showToast = (function () {
  var activeToast;
  return function (toastClass, params, options) {
    // don't allow multiple toasts: remove the previous
    // one before adding the new toast
    if (activeToast) {
      activeToast.remove();
    }
    var toastViewParams = _.extend({}, params);
    var toastView = React.createElement(toastClass, toastViewParams);
    activeToast = $('<div/>');
    activeToast.addClass('DesignSystem');

    var destroy = function () {
      if (activeToast.length) {
        activeToast.remove();
      }
    };

    var baseOptions = _.extend({}, options, {
      toastView: toastView,
      onClose: destroy,
    });

    var toastViewBase = React.createElement(
      Components.Toasts.ToastBase,
      baseOptions,
    );

    $('body').append(activeToast);
    return ReactDOM.render(toastViewBase, activeToast[0]);
  };
})();
